import React from 'react';
import { Table, Button } from 'antd';
import moment from 'moment';

import s from './style.less';
import NavBar from '../../components/NavBar';
import Breadcrubms from '../../components/Breadcrumb';

class CustomerPlans extends React.Component {
  state = {
    list: [],
  };

  componentDidMount() {
    this.fetchList();
  }

  breadcrumbs = [
    { name: 'Home', to: '/customer/plans' },
    { name: 'View Docs' },
  ];

  columns = [
    {
      title: 'Contract number',
      dataIndex: 'contractNumber',
      key: 'contract_number',
    },
    {
      title: 'Created',
      dataIndex: 'createdAt',
      key: 'created',
      render: date => moment(date).format('DD/MM/YYYY'),
    },
    {
      title: 'Documents',
      key: 'action',
      dataIndex: 'id',
      render: (id, row) => (
        <span>
          <a
            href="/docs/kam.pdf"
            className={s.actionButton}
            download="Terms And Conditions.pdf"
          >
            <Button type="primary" className={s.actionButton}>
              Service Plan Terms & Conditions
            </Button>
          </a>
          <a
            href={`/reports/plan/${id}`}
            className={s.actionButton}
            download={`${row.contractNumber}.pdf`}
          >
            <Button type="primary" className={s.actionButton}>
              Download Plan
            </Button>
          </a>
          <a
            href={`/reports/plan/${id}`}
            className={s.actionButton}
            target="_blank"
          >
            <Button type="primary" className={s.actionButton}>
              View Plan
            </Button>
          </a>
        </span>
      ),
    },
  ];

  fetchList = async () => {
    const list = await fetch('/customer/my-plans');
    this.setState({ list });
  };

  render() {
    const { list } = this.state;

    return (
      <NavBar withPadding>
        <Breadcrubms paths={this.breadcrumbs} />
        <div className={s.title}>Plan Details</div>
        <Table columns={this.columns} rowKey="id" dataSource={list} />
      </NavBar>
    );
  }
}

export default CustomerPlans;
